import React from 'react';
import { Link } from 'react-router-dom';

import styles from './agenciesHome.module.scss';
import i18n from 'i18n';

import { SearchBar } from 'components/common/SearchBar';
import { AgencyList } from 'components/AgencyList';
import { AgenciesHomeProps, AgenciesHomeState } from './AgenciesHomeModel';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { isRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';
import { FilterMenuTab } from 'components/common/FilterMenuTab/FilterMenuTab';

export class AgenciesHome extends React.Component<
  AgenciesHomeProps,
  AgenciesHomeState
> {
  handler: number;

  constructor(props: any) {
    super(props);
    this.state = this.props.model.state;
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
  }

  componentDidMount() {
    this.props.model.fetch();
  }

  componentDidUpdate(prevProps: AgenciesHomeProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
      this.props.model.fetch();
    }
  }

  componentWillUnmount() {
    this.props.model.event.remove(this.handler);
  }

  render() {
    return (
      <div className={styles.agenciesHome}>
        {this.state.loading && <LoadingIndicator />}
        <div className={styles.topPanel}>
          <h3>{this.props.model.title}</h3>
        </div>
        <div className={styles.operationPanel}>
          <PermissionChecker permissionAware={isRoles(RoleNames.sysAdmin)}>
            <Link to='/agencies/new' className={'btn btn-tertiary btn-sm'}>
              {i18n.t('agencies.home.addAgency')}
            </Link>
          </PermissionChecker>
          <FilterMenuTab
            filterMenuTabConfigs={this.props.model.filterMenuTabConfigs}
          />
          <SearchBar model={this.props.model} />
        </div>
        <div className={styles.listContainer}>
          <AgencyList model={this.props.model.listModel} />
        </div>
      </div>
    );
  }
}
